import useHttp from '@/shared/hooks/useHttp'
import { useDispatch, useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { useTranslation } from 'react-i18next'
import { selectOrganizationsManagementState } from '@/containers/OrganizationsManagement/organizationsManagementSelectors'
import { useNavigate } from 'react-router'
import { useSnackbarNotification } from '@/shared/tools/notifications/useSnackbarNotification'
import { SNACKBAR_TYPES } from '@/shared/tools/notifications/notification'
import useBusinessType from '@/shared/hooks/useBusinessType'

const useSaveOffer = (saveFn) => {
  const { country, loaderRoutesEnergy, loaderRoutes, loaderRoutesInsurance } = useSelector(selectAuthData)
  const dispatch = useDispatch()
  const providerState = useSelector(selectOrganizationsManagementState)
  const { sendRequest, getConfig } = useHttp()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const showNotification = useSnackbarNotification()
  const { type } = useBusinessType({
    loaderRoutesEnergy,
    loaderRoutes,
    loaderRoutesInsurance,
    modulesStatuses: {},
    modulesStatusesEnergy: {},
    modulesStatusesInsurance: {},
  })

  const saveOffer = () => {
    saveFn(
      providerState,
      dispatch,
      providerState.routes.offers.save + '?lang=' + country,
      getConfig('POST'),
      sendRequest,
      country,
      {
        onSuccess: () => {
          showNotification({ type: SNACKBAR_TYPES.SUCCESS, message: t('organizationManagement:offerSaved') })
          navigate('/' + type + '/organisations/provider/' + providerState.selectedProvider.uuid)
        },
      },
    )
  }

  return { saveOffer }
}

export default useSaveOffer
